/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TerminiStatoDTO { 
    attivo?: boolean;
    versione_corrente?: string;
    versione_accettata?: string;
    data_accettazione?: string;
    da_accettare?: boolean;
    aggiornamento?: boolean;
    testo_html?: string;
}

